module.exports = "<div class=\"ledgerEntry\" *ngFor=\"let ledger of ledgers;\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-6\">{{ledger.description}}</div>\r\n        <div class=\"col-xs-6\">{{ledger.trxnAmount | number:'1.2-2'}}</div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-6\">{{ledger.trxnTime}}</div>\r\n        <div class=\"col-xs-3\">{{ledger.balanceBefore | number:'1.2-2'}}</div>\r\n        <div class=\"col-xs-3 after\">{{ledger.balanceAfter | number:'1.2-2'}}</div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Customer/customerLedger.component.html
// module id = 481
// module chunks = 1